import { useMemo } from 'react';

import { Budget } from '@bonusly/common-action-input';
import { useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

export const useBudget = () => {
	const company = useCurrentCompany();
	const user = useCurrentUser();

	return useMemo(() => {
		return new Budget({
			allowance: user.monthly_allowance,
			balance: user.giving_balance,
			display: {
				singular: company.budget.singular,
				plural: company.budget.plural,
			},
			flashPointsBalance: user.flash_points_balance,
			format: {
				singular: company.budget.format.singular,
				plural: company.budget.format.plural,
			},
		});
	}, [company, user]);
};
